import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { SalesPortalOrderEntryTable_OrderEntryItemFieldsFragmentDoc } from './sales-portal-order-entry-item-fields.generated';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const GetOrderEntryItemsFromVariantPackIdsDocument = gql`
  query GetOrderEntryItemsFromVariantPackIds(
    $supplierId: uuid!
    $restaurantId: uuid!
    $variantPackIds: [uuid!]!
    $deliveryDate: String
  ) {
    getOrderEntryItemsFromVariantPackIds(
      supplier_id: $supplierId
      restaurant_id: $restaurantId
      variant_pack_ids: $variantPackIds
      delivery_date: $deliveryDate
    ) {
      order_entry_items {
        ...SalesPortalOrderEntryTable_OrderEntryItemFields
      }
    }
  }
  ${SalesPortalOrderEntryTable_OrderEntryItemFieldsFragmentDoc}
`;
export function useGetOrderEntryItemsFromVariantPackIdsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.GetOrderEntryItemsFromVariantPackIdsQuery,
    Types.GetOrderEntryItemsFromVariantPackIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.GetOrderEntryItemsFromVariantPackIdsQuery,
    Types.GetOrderEntryItemsFromVariantPackIdsQueryVariables
  >(GetOrderEntryItemsFromVariantPackIdsDocument, options);
}
export function useGetOrderEntryItemsFromVariantPackIdsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.GetOrderEntryItemsFromVariantPackIdsQuery,
    Types.GetOrderEntryItemsFromVariantPackIdsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.GetOrderEntryItemsFromVariantPackIdsQuery,
    Types.GetOrderEntryItemsFromVariantPackIdsQueryVariables
  >(GetOrderEntryItemsFromVariantPackIdsDocument, options);
}
export type GetOrderEntryItemsFromVariantPackIdsQueryHookResult = ReturnType<
  typeof useGetOrderEntryItemsFromVariantPackIdsQuery
>;
export type GetOrderEntryItemsFromVariantPackIdsLazyQueryHookResult =
  ReturnType<typeof useGetOrderEntryItemsFromVariantPackIdsLazyQuery>;
export type GetOrderEntryItemsFromVariantPackIdsQueryResult =
  Apollo.QueryResult<
    Types.GetOrderEntryItemsFromVariantPackIdsQuery,
    Types.GetOrderEntryItemsFromVariantPackIdsQueryVariables
  >;

/**
 * Wrapped version of useGeneratedGetOrderEntryItemsFromVariantPackIdsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedGetOrderEntryItemsFromVariantPackIdsQuery(
  options?: Apollo.QueryHookOptions<
    Types.GetOrderEntryItemsFromVariantPackIdsQuery,
    Types.GetOrderEntryItemsFromVariantPackIdsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.GetOrderEntryItemsFromVariantPackIdsQuery,
    Types.GetOrderEntryItemsFromVariantPackIdsQueryVariables
  >(GetOrderEntryItemsFromVariantPackIdsDocument, options);
}

/**
 * Wrapped version of useGeneratedGetOrderEntryItemsFromVariantPackIdsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedGetOrderEntryItemsFromVariantPackIdsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.GetOrderEntryItemsFromVariantPackIdsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.GetOrderEntryItemsFromVariantPackIdsQuery,
    Types.GetOrderEntryItemsFromVariantPackIdsQueryVariables
  >(GetOrderEntryItemsFromVariantPackIdsDocument, lazyOptions);
}
